'use client';

import { LazyMotion, domAnimation, useScroll, useSpring, motion } from 'framer-motion';
import SceneStream from './components/SceneStream';
import SceneOverflow from './components/SceneOverflow';
import Scene05Mascot from './components/Scene05Mascot';
import TrustStrip from './components/TrustStrip';
import type { LandingStats } from '@shared/services/landingStatsFormat';
import Scene06Categories from './components/Scene06Categories';
import Scene07Covers from './components/Scene07Covers';
import Scene08Swipe from './components/Scene08Swipe';
import Scene09Magic from './components/Scene09Magic';
import Scene10Voting from './components/Scene10Voting';
import Scene11Final from './components/Scene11Final';
import PricingSection from './components/PricingSection';
import FaqSection from './components/FaqSection';
import BackToPrevious from './components/BackToPrevious';

interface Props {
  botUrl: string;
  vkUrl: string;
  stats: LandingStats;
}

export default function ScrollStory({ botUrl, vkUrl, stats }: Props) {
  const { scrollYProgress } = useScroll();
  const progressX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.4 });

  return (
    <LazyMotion features={domAnimation}>
      <motion.div
        aria-hidden
        className="fixed top-14 left-0 right-0 h-[2px] bg-[#b7102a] origin-left z-40"
        style={{ scaleX: progressX }}
      />

      <main className="relative">
        <SceneStream />
        <SceneOverflow />
        <div id="scene-mascot"><Scene05Mascot /></div>
        <TrustStrip stats={stats} />
        <div id="scene-categories"><Scene06Categories /></div>
        <div id="scene-covers"><Scene07Covers /></div>
        <div id="scene-swipe"><Scene08Swipe /></div>
        <div id="scene-magic"><Scene09Magic /></div>
        <div id="scene-voting"><Scene10Voting /></div>
        <PricingSection />
        <FaqSection />
        <div id="scene-final"><Scene11Final botUrl={botUrl} vkUrl={vkUrl} /></div>
      </main>

      <BackToPrevious />
    </LazyMotion>
  );
}
